import React, { Component } from 'react';
import { Modal, PanelGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { reduxForm } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import { AdminApi } from '../../../../api';
import { setLoader, removeLoader } from '../../../../actions';
import { convertDollarsToMills } from '../../../../utils/helpers/currency';
import WizardFormStep1 from './wizard/WizardFormStep1';
import WizardFormStep2 from './wizard/WizardFormStep2';
import WizardFormStep3 from './wizard/WizardFormStep3';
import WizardFormStep4 from './wizard/WizardFormStep4';
import WizardFormStep5 from './wizard/WizardFormStep5';

class NewFeedCampaignForm extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      page: 1,
      maxPage: 1,
      backtracking: false,
      campaignId: null
    };
  }

  onFormSubmit(values) {
    const { dispatch, resourceData, resourceName } = this.props;
    const modifierList = {};
    const formData = { ...values };

    if (formData.modifiers) {
      formData.modifiers.forEach(m => {
        modifierList[m.field] = { method: m.method, value: m.value };
        return m;
      });
    }

    if (formData.feed_type) {
      const feedType = ['http', 'http_auth'].includes(formData.feed_type) ? 'http' : 'ftp';
      formData.credentials = { [formData.feed_type]: formData.credentials[feedType] };
      delete formData.feed_type;
    }

    const unmappedList = formData.unmapped_list ? formData.unmapped_list.split(',') : [];

    const campaignData = {
      ...formData.details,
      budget: convertDollarsToMills(formData.details.budget),
      bid: convertDollarsToMills(formData.details.bid),
    };

    const templateData = {
      credentials: formData.credentials,
      mapping: formData.mapping,
      filter_list: { and: formData.and },
      modifier_list: modifierList,
      filter: formData.filter || false,
      root: formData.root,
      schedule: `${formData.cron} ${formData.cron_timezone}`,
      unmapped_list: unmappedList,
      gzip: formData.gzip,
      video: formData.video || false,
    };

    if (templateData.filter_list.and === undefined) {
      delete templateData.filter_list;
    }

    if (templateData.video === false) { templateData.mapping.videourl = null; }

    dispatch(setLoader('adminCampaignForm'));

    if (this.state.campaignId === null) {
      dispatch(AdminApi.actions.feedCampaignCreate.post(campaignData, (_error, success) => {
        if (success) {
          resourceData.data.unshift(success.data);

          dispatch({
            type: AdminApi.events[resourceName].actionSuccess,
            syncing: false,
            data: { ...resourceData, data: resourceData.data, meta: { ...resourceData.meta } }
          });

          this.setState({ campaignId: success.data.id }, () => {
            this.createTemplate(this.state.campaignId, templateData);
          });
        } else {
          dispatch(removeLoader('adminCampaignForm'));
        }
      }));
    } else {
      this.createTemplate(this.state.campaignId, templateData);
    }
  }

  createTemplate(campaignId, data) {
    const { dispatch, handleHide, templates } = this.props;

    dispatch(AdminApi.actions.feedTemplateCreate.post({ ...data, campaign_id: campaignId }, (_error, success) => {
      dispatch(removeLoader('adminCampaignForm'));

      if (success) {
        toastr.success('Successfully created campaign and feed template!');
        templates.data.unshift(success.data);

        dispatch({
          type: AdminApi.events.feedTemplate.actionSuccess,
          syncing: false,
          data: { ...templates, data: templates.data, meta: { ...templates.meta } }
        });

        this.props.destroy();
        handleHide();
      } else {
        toastr.warning('Successfully updated campaign details but unable to update feed template. Please try updating again!');
      }
    }));
  }

  nextPage() {
    const { page, maxPage } = this.state;
    if (page === maxPage) {
      this.setState({ page: page + 1, maxPage: maxPage + 1, backtracking: false });
    } else {
      this.setState({ page: page + 1, backtracking: false });
    }
  }

  previousPage() {
    if (this.state.backtracking) {
      this.setState({ page: this.state.page - 1 });
    } else {
      this.setState({ page: this.state.page - 1, maxPage: this.state.page, backtracking: true });
    }
  }

  changePage(pageNumber) {
    const { maxPage } = this.state;

    if (pageNumber <= maxPage) { this.setState({ page: pageNumber, backtracking: false }); }
  }

  handleShow() {
    const { handleHide, resource, onShow } = this.props;
    handleHide();
    onShow(resource.uuid, resource);
  }

  handleHide(force = true) {
    const { dirty, handleHide } = this.props;
    if (!dirty || force) {
      this.props.destroy();
      handleHide();
    } else {
      toastr.warning('You have unsaved changes to your template.  Please save before exiting or press Close to continue without saving');
    }
  }

  render() {
    const {
      show,
      heading,
      accountOptions,
      feedFormType,
      isAuthUrl,
      useFilters,
      isRecurring,
      handleSubmit,
      includesVideo,
      hasSecureShell,
    } = this.props;
    const { page } = this.state;
    const pillStyles = {
      flexGrow: '1',
      borderRadius: '5px',
      backgroundColor: '#70D1BD',
      padding: '5px 10px',
      color: 'white',
      cursor: 'pointer',
      maxWidth: '150px',
      minWidth: '150px',
    };

    return (
      <Modal show={show} onHide={this.handleHide.bind(this)} bsSize='large'>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>

        <div className='m-t'>
          <Modal.Body>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginBottom: '20px' }}>
              {
                ['Details', 'Credentials', 'Mapping', 'Filters', 'Modifiers'].map((p, i) => {
                  return (
                    <div
                      key={i}
                      style={pillStyles}
                      className={page === i + 1 && 'currentPill'}
                      onClick={handleSubmit(this.changePage.bind(this, i + 1))}
                    >
                      {`${i + 1}. ${p}`}
                    </div>
                  );
                })
              }
            </div>
            <PanelGroup id='template-panels' style={{ minHeight: '600px' }}>
              { page === 1 && <WizardFormStep1 isRecurring={isRecurring} accountOptions={accountOptions} onSubmit={this.nextPage} /> }
              {
                page === 2 &&
                <WizardFormStep2
                  feedFormType={feedFormType}
                  isAuthUrl={isAuthUrl}
                  hasSecureShell={hasSecureShell}
                  onSubmit={this.nextPage}
                  prevPage={this.previousPage}
                />
              }
              { page === 3 && <WizardFormStep3 onSubmit={this.nextPage} prevPage={this.previousPage} includesVideo={includesVideo} /> }
              { page === 4 && <WizardFormStep4 onSubmit={this.nextPage} useFilters={useFilters} prevPage={this.previousPage} /> }
              { page === 5 && <WizardFormStep5 onSubmit={this.onFormSubmit.bind(this)} prevPage={this.previousPage} /> }
            </PanelGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleHide.bind(this, true)}>Close</Button>
          </Modal.Footer>
        </div>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'AdminNewFeedCampaignForm',
  destroyOnUnmount: false,
});

const ResourceModal = connectModal({
  name: 'AdminNewFeedCampaignModal'
});

const mapStateToProps = (state) => {
  const { loader, modal: { AdminNewFeedCampaignModal }, admin: { account } } = state;
  const isLoading = loader.includes('adminFeedTemplateForm');
  const resourceName = get(AdminNewFeedCampaignModal, 'props.resourceName', null);
  const resourceData = get(state, `admin.${resourceName}.data`, {});
  const templates = get(state, 'admin.feedTemplate.data', {});

  const feedFormType = get(state.form, 'AdminNewFeedCampaignForm.values.feed_type', null);
  const isAuthUrl = get(state.form, 'AdminNewFeedCampaignForm.values.credentials.has_auth', false);
  const useFilters = get(state.form, 'AdminNewFeedCampaignForm.values.filter', false);
  const isRecurring = get(state.form, 'AdminNewFeedCampaignForm.values.details.recurring', false);
  const includesVideo = get(state.form, 'AdminNewFeedCampaignForm.values.video', false);
  const hasSecureShell = get(state.form, 'AdminNewFeedCampaignForm.values.credentials.ftp.ssh_login', false);

  const accountOptions = (account.data.data || []).map(a => ({ label: `${a.advertiser} - ${a.name}`, value: a.id }));

  const initialValues = { cron: '0 */6 * * *', cron_timezone: 'EST' };

  return {
    isLoading,
    resourceData,
    feedFormType,
    isAuthUrl,
    useFilters,
    isRecurring,
    accountOptions,
    templates,
    initialValues,
    includesVideo,
    hasSecureShell
  };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(NewFeedCampaignForm)));
